exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".required-field{color:red!important;font-weight:600!important}.required-message{color:red;font-family:Open Sans,Crimson Text;font-weight:600;margin-top:2px}.form-note{font-weight:500;color:var(--coredarkcolor);margin-top:.5em;margin-bottom:.5em}.fee-note{margin-bottom:-.5em}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-8022ac78","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/employers/applications/FamilyForm.vue
// module id = 812
// module chunks = 0